import React, { useState, useRef, useEffect, useContext } from 'react'
import { TextField, MenuItem, makeStyles, IconButton } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import { ContextProvider } from '../globalContextProvider';
import ClearIcon from '@material-ui/icons/Clear';
const useStyles = makeStyles({
    input: {
        padding: "0px 10px",
        height: 30,
        color: "#90A0B7",
        fontSize: 12
    },
    paper: {
        background: "#F5F8FA",
        boxShadow: "none",
        marginTop: 50

    },
    noBorder: {
        border: "none",
    },
});

export default function CustomSearch(props) {
    const { setIsChange } = useContext(ContextProvider);
    const classes = useStyles()
    const { setSearch, searchTypes, setSearchTypes, searchTypeState, search, saveInputFlag, pathName, customSearchStyle, placeholder, changePageWhileSearch ,vehicleSummary} = props
    const [inputSearch, setInputSearch] = useState(search ? search : "")
    const searchTimeout = useRef(null)
    const handleChange = (event) => {
        setInputSearch(event.target.value);
    };

    const actionHandler = (event) => {
        setSearchTypes(event.target.value);
    };

    
    const searchHandler = () => {
        if(vehicleSummary){
            changePageWhileSearch(0);
        }
        setSearch(inputSearch)
        if (pathName) {

            let prevValue = { inputSearch: inputSearch, type: searchTypes }
            if (sessionStorage.getItem(pathName)) {
                let prevdata = JSON.parse(sessionStorage.getItem(pathName))
                sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, ...prevValue }))
            } else {
                sessionStorage.setItem(`${pathName}`, JSON.stringify(prevValue))
            }
        }
        if (saveInputFlag) {
            sessionStorage.setItem('parkingSearch', inputSearch);
        }

        if (inputSearch !== "") {
            setIsChange(true)
        }
    }

    const clearSearchHandler = () =>{
        setInputSearch('')
    }
      
    useEffect(() => {
        setIsChange(false)
        if (searchTimeout.current)
            clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => searchHandler(), 800);
    }, [inputSearch]);  // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div className='customSearch addBorderRadius' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", columnGap: 5, fontFamily: "Poppins-Medium", flex: 1, minWidth: '280px', ...customSearchStyle }}>
            <div style={{ display: "flex", justifyContent: "start", alignItems: "center", flex: 1, columnGap: 10 }}>
                <SearchIcon style={{ fontSize: "20px", fill: "#C2CFE0" }} />
                <input className='customInputFilter'
                    type="text"
                    value={inputSearch}
                    onChange={handleChange}
                    placeholder= {placeholder ? placeholder :'Search'}
                    style={{ fontFamily: "Poppins-Medium", fontWeight: 500 }}
                />
            {inputSearch && <IconButton style={{ width: 35, height: 35, marginRight:-15 }} onClick={clearSearchHandler}><ClearIcon style={{ fill: '#90A0B7' }}/></IconButton>}
            </div>
            <TextField
                size="small"
                variant='outlined'
                InputProps={{
                    className: classes.input,
                    classes: { notchedOutline: classes.noBorder }
                }}
                InputLabelProps={{ shrink: false, }}
                SelectProps={{
                    MenuProps: {
                        PaperProps: {
                            className: classes.paper
                        }
                    }
                }}
                select
                value={searchTypes}
                onChange={actionHandler}
            >
                {searchTypeState.length !== 0 && searchTypeState.map(item => {
                    return <MenuItem className="customSelectStyle" value={item}>{item}</MenuItem>;
                })}
            </TextField>
            <div>
            </div>
        </div>
    );
}

